/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {FsVerticalAlignmentComponent as ɵa} from './lib/components/fs-vertical-alignment/fs-vertical-alignment.component';
export {MapperPipe as ɵb} from './lib/pipes/mapper.pipe';
export {SHARED_ABP_MODULES as ɵc} from './lib/shared-abp.module';